import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import { Arr_DeclarationsInfo } from "../../../../arrays/SEF/Arr_DeclarationsInfo";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import { Arr_SEFPages } from "../../../../arrays/SEF/Arr_SEFPages";

function ViewSEFDeclarationsInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formInfo, setformInfo] = useState({});

  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit(
      "DeclarationsInfo",
      formInfo,
      Arr_DeclarationsInfo
    );

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    DeclarationsInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFDeclarationsInfo",
      setformInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  //check if every Prop in Arr_SEFPages called "Prop" exists in SEFProgress and is equal to "Complete" or "Awaiting_Review", unless it is the DeclarationsInfo page
  const PageComplete = Arr_SEFPages.every((Prop) => {
    return (
      Prop.Prop === "DeclarationsInfo" ||
      (SEFProgress[Prop.Prop] &&
        (SEFProgress[Prop.Prop] === "Complete" ||
          SEFProgress[Prop.Prop] === "Awaiting_Review"))
    );
  });

  const isFormComplete = neededToSubmit.length === 0 && PageComplete;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFDeclarationsInfo: formInfo,
        "SEFProgress.DeclarationsInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFDeclarationsInfo: formInfo,
        "SEFProgress.DeclarationsInfo": "Awaiting_Review",
        "SEFInfo.SEFSubmissionDate": new Date().toISOString(),
        "SEFInfo.SEF": "Awaiting_Review",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      DeclarationsInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  return (
    <div className="view-basic-info-container">
      <h1>Summer Information</h1>
      {SEFProgress &&
      SEFProgress.DeclarationsInfo &&
      (SEFProgress.DeclarationsInfo === "Complete" ||
        SEFProgress.DeclarationsInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}

      <form className="view-basic-info-form">
        <h2>Declarations</h2>
        <h3>Medical Consent</h3>
        <p>
          To be completed by parent/ legal guardian <b>ONLY.</b>
          <br></br>
          <br></br>
          All international students attending a summer programme must have
          valid comprehensive travel insurance, including medical coverage for
          the entire duration of their programme.
          <br></br>
          <br></br>
          InvestIN will make every reasonable effort to contact you should a
          medical emergency arise. However, you understand that in an emergency
          InvestIN reserves the right to act in place of a parent. By signing
          this page you agree that:<br></br>
          <br></br>
          1. In the event of an emergency, I agree for my child to receive
          on-site first aid or emergency medical treatment
          <br></br>
          2. I understand that in the event of sudden illness, accident, or
          injury, InvestIN will obtain NHS services for medical treatment and
          assessment, and I will be contacted and informed as soon as possible.
        </p>
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[0]}
        />
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[1]}
        />
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[2]}
        />
        <h3>Filming</h3>
        <p>
          Throughout the summer, InvestIN will capture video footage and take
          photographs for the use of media and promotional purposes. This will
          include visuals of attending students and staff.
          <br></br>
          <br></br>
          By law, we are required to obtain informed parental consent to take
          pictures, and video footage, and use these for promotional purposes.
          We understand that not all young people want to be part of pictures
          and footage and in some cases may have circumstances that dictate
          consent is obtained
          <br></br>
          <br></br>
          To be completed by <b>BOTH</b> parent/ guardian and student
        </p>
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[3]}
        />{" "}
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[4]}
        />
        <h3>Student behavior and safety</h3>
        <p>
          To be completed by <b>BOTH</b> parent/ guardian and student.
          <br></br>
          <br></br>
          InvestIN has a duty of care to ensure that all attendees are made
          aware of the expected behaviours when attending a summer experience.
          You must read the documents below and tick the box to indicate that
          you have understood the terms and will abide by the expectations and
          rules .
        </p>
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[5]}
        />
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[6]}
        />
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[7]}
        />
        <DisplayTextField
          formInfo={formInfo}
          handleChange={handleChange}
          Object={Arr_DeclarationsInfo[8]}
        />
        <h3>Declaration</h3>
        <p>
          I declare all information given is correct and honest, and if any of
          the above information changes I will inform InvestIN at my earliest
          convenience by emailing info@investin.org. If InvestIN staff are
          concerned about the wellbeing or safety of a student we reserve the
          right to end the summer experience and return the student to their
          family.{" "}
        </p>
        {/* ////////////// */}
        <SEFChangePage
          Page={"DeclarationsInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        {isFormComplete ? (
          <></>
        ) : (
          <table>
            <thead>
              <tr>
                <th>
                  {PageComplete
                    ? ""
                    : "Please ensure all other pages are completed before attempting to submit this page"}
                  <br></br>
                  <br></br>
                  {neededToSubmit.length === 0
                    ? ""
                    : "You can save this page at any point. To submit this page, please complete the following questions first:"}
                </th>
              </tr>
            </thead>
            <tbody>
              {neededToSubmit.map((Obj) => {
                return (
                  <tr key={Obj.name}>
                    <td>{Obj.label}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}{" "}
        <h3>
          Once this page is completed and you have completed every question,
          please click "Submit" to complete the page and send it for review by
          InvestIN. Otherwise, click "Save" if you are not ready to complete the
          page and wish to return later to make changes
        </h3>
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.DeclarationsInfo &&
                (SEFProgress.DeclarationsInfo === "Complete" ||
                  SEFProgress.DeclarationsInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.DeclarationsInfo &&
                (SEFProgress.DeclarationsInfo === "Complete" ||
                  SEFProgress.DeclarationsInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewSEFDeclarationsInfo;
